import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_f049ee2b-edae-4cc4-8e76-bfc796e90f9f/artifacts/cqza8cpe_logo-pass-algarve.png";

/**
 * PassAlgarveLogo
 * Source PNG: 1600x1067 with a black background.
 * Visible gold artwork bbox (measured): 16%–86% horizontally, 31.5%–68.5% vertically.
 * That gives a 1120x395 visible region (≈ 2.84 : 1 aspect).
 *
 * We render the image as a `background-image` on a container sized exactly
 * to the visible artwork, with the background scaled and offset so the
 * visible artwork's top-left lands at the container's (0,0).
 *
 * `mixBlendMode: screen` makes the surrounding black pixels transparent
 * so the gold logo works on any background.
 */
export const PassAlgarveLogo = ({ className = "", size = "default" }) => {
  const sizes = {
    small:   { h: 52  },
    default: { h: 76  },
    large:   { h: 108 },
  };

  const { h } = sizes[size] || sizes.default;

  // Scale factor so the visible artwork height = container height `h`
  // visibleArtworkHeight = 0.37 * 1067 = 394.79
  const scale = h / 394.79;
  const bgWidth   = 1600 * scale;
  const bgHeight  = 1067 * scale;
  const offsetX   = 1600 * 0.16  * scale; // 256 * scale
  const offsetY   = 1067 * 0.315 * scale; // 336 * scale
  const visibleWidth = 1120 * scale;      // 70% of source width

  return (
    <div
      className={`inline-block ${className}`}
      style={{
        height: `${h}px`,
        width: `${visibleWidth}px`,
        backgroundImage: `url(${LOGO_URL})`,
        backgroundSize: `${bgWidth}px ${bgHeight}px`,
        backgroundPosition: `-${offsetX}px -${offsetY}px`,
        backgroundRepeat: 'no-repeat',
        mixBlendMode: 'screen',
      }}
      role="img"
      aria-label="PASS Algarve"
    />
  );
};

// QR mark: dedicated asset (gold QR on navy tile) — no sprite cropping
export const PassAlgarveQrMark = ({ className = "", size = 40 }) => (
  <img
    src="/qr-mark.png"
    width={size}
    height={size}
    className={`inline-block ${className}`}
    style={{ objectFit: "contain", borderRadius: `${Math.max(3, size * 0.08)}px` }}
    alt="PASS Algarve QR"
  />
);

// Compact variant kept for backward compatibility
export const PassAlgarveLogoCompact = ({ className = "" }) => (
  <PassAlgarveLogo size="small" className={className} />
);

export default PassAlgarveLogo;
